import { QueryClientConfig } from '@tanstack/react-query';

const config: QueryClientConfig = {
    defaultOptions: {
        queries: {
            // query options
        },
        mutations: {
            // mutation options
        },
    },
};

export default config;
